// @flow

import {
  WebsiteChatConfig,
  type GenericEventConfig,
  type GoogleAnalyticsSendOption,
  type ShowSetting,
  type LiveChatType,
  DATA_RETENTION_PERIOD_DEFAULT
} from '@chatchamp/chatchamp-types'

import type {
  CustomDataLayerConfig,
  MatomoConfig,
  TealiumConfig,
  TrackingProvider
} from '@chatchamp/chatchamp-types'

export class Shop implements WebsiteChatConfig {
  // $FlowFixMe
  animateAvatar: boolean
  // $FlowFixMe
  animatedAvatarImageUrl: string
  // $FlowFixMe
  avatarImageUrl: string
  // $FlowFixMe
  backgroundColor: string
  customCss: string
  // $FlowFixMe
  customerMatching: string
  enabled: boolean
  googleAnalytics: {
    events: Array<GenericEventConfig>,
    wizardEvents: Array<GenericEventConfig>,
    sendOption: GoogleAnalyticsSendOption
  }

  tracking: {
    trackingProvider: TrackingProvider,
    tealiumConfig?: TealiumConfig,
    matomoConfig?: MatomoConfig,
    customDataLayerConfig?: CustomDataLayerConfig
  }

  dataPrivacy: {
    enablePostHog: boolean,
    dataRetentionPeriod: number
  }

  liveChat: {
    type: ?LiveChatType
  }

  // $FlowFixMe
  show: ShowSetting
  // $FlowFixMe
  zIndex: number
  // $FlowFixMe
  isEnabledABTest: boolean
  // $FlowFixMe
  alignBotMobile: ?('right' | 'left')
  // $FlowFixMe
  alignBotDesktop: ?('right' | 'left')

  locale: string

  constructor (websiteChatConfig: WebsiteChatConfig) {
    // $FlowFixMe
    websiteChatConfig && Object.assign(this, websiteChatConfig)
    this.liveChat = this.liveChat || {}
  }

  getAlignBotMobile (): 'left' | 'right' {
    // $FlowFixMe
    return this.alignBotMobile || 'right'
  }

  getSpacingSideMobile (): number {
    // $FlowFixMe
    return parseInt(this.spacingSideMobile || 20)
  }

  getSpacingBottomMobile (): number {
    // $FlowFixMe
    return parseInt(this.spacingBottomMobile || 20)
  }

  getAlignBotDesktop (): 'left' | 'right' {
    // $FlowFixMe
    return this.alignBotDesktop || 'right'
  }

  getSpacingSideDesktop (): number {
    // $FlowFixMe
    return parseInt(this.spacingSideDesktop || 20)
  }

  getSpacingBottomDesktop (): number {
    // $FlowFixMe
    return parseInt(this.spacingBottomDesktop || 20)
  }

  getZIndex (): number {
    // $FlowFixMe
    return parseInt(this.zIndex || 1000)
  }

  cookieMaxAgeInDays (): number {
    if (typeof this.dataPrivacy?.dataRetentionPeriod === 'number') {
      return this.dataPrivacy?.dataRetentionPeriod
    }

    return DATA_RETENTION_PERIOD_DEFAULT
  }
}
